export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0028.6f333a22.webp";